import React from 'react';

import SidebarMenu from '../../components/SidebarMenu';
import Header from '../../components/Header';

const AdminPage = props => {
    return (
        <div className="wrapper">
            <div className="main-container">
                <div className="main-menu">
                    <SidebarMenu />
                </div>
                <div className="page-container">
                    <Header />
                    { props.children }
                </div>
            </div>
        </div>
    )
}

export default AdminPage;